import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";

const ComingSoon = () => {
  return (
    <>
      <Helmet>
        <title>Coming Soon - MacroVault</title>
        <meta name="description" content="This feature is coming soon to MacroVault." />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1 container mx-auto px-4 pt-32 pb-24 max-w-3xl">
          <h1 className="text-4xl font-bold mb-6 text-center">Coming Soon</h1>
          
          <p className="text-foreground/80 text-center text-lg">
            We're working on something exciting. Stay tuned!
          </p>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ComingSoon;
